export default "__VITE_ASSET__BrSqWOXy__"